import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    placeholder: {
      position: 'relative',
      display: 'block',
      width: '100%',

      '& > [data-slate-placeholder]': {
        color: COLORS.gray.gray40,
        opacity: '1 !important', // override Slate's inline placeholder style
        paddingRight: theme.spacing(4),
      },
    },
  }),
  { name: 'TextLeaf' }
);
